import svgSprite from '@hashicorp/flight-icons/svg-sprite/svg-sprite.svg'
import classNames from 'classnames'
import { useId, type SVGProps } from 'react'
import s from './style.module.css'

interface Props extends SVGProps<SVGSVGElement> {
	/**
	 * The name of the icon you wish to use. If the value does not match an
	 * existing icon name, an error will be thrown. Search for existing icon
	 * names in the Icon library.
	 */
	name: string

	/**
	 * The `color` prop can be used to change the color. It works by setting
	 * the value of the icon SVG’s fill property.
	 */
	color?: string

	className?: string
}

// When an SVG file is imported in Next.js, it is an object with a `src`
// property. However, tools like Webpack and Vite default to returning a URL.
// This runtime check allows the component to work in all of these cases.
const svgSpriteSrc =
	typeof svgSprite === 'string' ? svgSprite : (svgSprite as { src: string }).src

export default function FlightIcon({
	name,
	color = 'currentColor',
	className,
	...rest
}: Props) {
	const iconId = useId()
	return (
		<svg
			className={classNames(s['flight-icon'], className)}
			{...rest}
			aria-hidden="true"
			fill={color}
			id={iconId}
			width={16}
			height={16}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<use href={`${svgSpriteSrc}#flight-${name}-16`}></use>
		</svg>
	)
}
